class SaleCountdown extends HTMLElement {
  connectedCallback() {
    this.startAt = Date.parse(this.dataset.start);
    this.endAt = Date.parse(this.dataset.end);
    this.labelEl = this.querySelector('[data-countdown-label]');
    this.cells = {};
    for (const unit of ['days', 'hours', 'minutes', 'seconds']) {
      this.cells[unit] = this.querySelector(`[data-unit="${unit}"]`);
    }
    this.initVariantSync();
    if (Number.isNaN(this.startAt) || Number.isNaN(this.endAt)) {
      this.setAttribute('data-state', 'live');
      return;
    }
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    if (this.variantHandler) {
      this.variantScope?.removeEventListener('variant:update', this.variantHandler);
    }
  }

  // Product-page callouts embed a per-variant price map; the theme's
  // variant picker only re-renders its own refs, so we sync from the
  // bubbling variant:update event (same hook local-pickup uses).
  initVariantSync() {
    const mapEl = this.querySelector('script[data-sale-map]');
    if (!mapEl) return;
    let saleMap;
    try {
      saleMap = JSON.parse(mapEl.textContent);
    } catch {
      return;
    }
    this.variantHandler = (event) => {
      const id = event.detail?.resource?.id;
      if (id == null) return;
      const entry = saleMap[String(id)];
      if (entry === undefined) return;
      if (entry === null) {
        this.style.display = 'none';
        return;
      }
      this.style.display = '';
      const orig = this.querySelector('[data-sale-original]');
      const sale = this.querySelector('[data-sale-price]');
      if (orig) orig.textContent = entry.original;
      if (sale) sale.textContent = entry.sale;
    };
    this.variantScope = this.closest('.shopify-section') || document;
    this.variantScope.addEventListener('variant:update', this.variantHandler);
  }

  tick() {
    const now = Date.now();
    let state, target;
    if (now < this.startAt) {
      state = 'upcoming';
      target = this.startAt;
    } else if (now < this.endAt) {
      state = 'live';
      target = this.endAt;
    } else {
      state = 'ended';
      target = null;
    }

    if (state !== this.state) {
      this.state = state;
      this.setAttribute('data-state', state);
      const label = this.dataset[`label${state[0].toUpperCase()}${state.slice(1)}`];
      if (this.labelEl && label) this.labelEl.textContent = label;
    }

    if (target === null) {
      clearInterval(this.timer);
      return;
    }

    let remaining = Math.max(0, Math.floor((target - now) / 1000));
    const parts = {
      days: Math.floor(remaining / 86400),
      hours: Math.floor((remaining % 86400) / 3600),
      minutes: Math.floor((remaining % 3600) / 60),
      seconds: remaining % 60,
    };
    for (const [unit, value] of Object.entries(parts)) {
      const cell = this.cells[unit];
      if (!cell) continue;
      const text = String(value).padStart(2, '0');
      if (cell.textContent !== text) cell.textContent = text;
    }
  }
}

if (!customElements.get('sale-countdown')) {
  customElements.define('sale-countdown', SaleCountdown);
}
